export default __webpack_public_path__ + "static/media/icon_fire_breakglass_on.73567c58.png";